import styled from "styled-components";
//#3d85c6
export const Styles = styled.div`
  background: #3d85c6;
  display: flex;
  position: sticky;
  top: 0;
  z-index: 10;
  .cell-item {
    border-right: 1px solid #e8e8e8;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: 500;
    font-size: 15px;
  }
  .cell-item-sticky {
    background: #3d85c6;
  }
`;
